import { element } from 'protractor';
import { PermissionVinculadasModel } from './../../../model/permission/permissionvinculadas.model';
import { GrupoVinculadoModel } from './../../../model/permission/grupovinculado.model';
import { GrupoPermissionModel } from './../../../model/permission/grupopermission.model';
import { PermissionModel } from './../../../model/permission/permission.model';
import { GroupModel } from './../../../model/permission/group.model';
import {
  FormControl,
  FormGroup,
  FormBuilder,
  Validators,
  FormArray,
} from '@angular/forms';
import { Router, ActivatedRoute } from '@angular/router';
import { AuthenticationService } from '@alfresco/adf-core';
import { Component, OnInit } from '@angular/core';
import { PermissionsService } from 'app/service/permission/permissions.service';
import { map } from 'rxjs/operators/map';
import { MatSnackBar, MatSnackBarHorizontalPosition, MatSnackBarVerticalPosition } from '@angular/material/snack-bar';

interface GrupoPermissaoMap {
  hasParamInstance: string;
  permissaoVinculadas: GrupoVinculadoModel[]
}

@Component({
  selector: 'app-create-grupo-permission',
  templateUrl: './create-grupo-permission.component.html',
  styleUrls: ['./create-grupo-permission.component.scss'],
})
export class CreateGrupoPermissionComponent implements OnInit {
  public grupoId: number;
  public formGrupoPermission: FormGroup;
  public formGrupoEdit: FormGroup;
  public submit = false;
  public group = {} as GroupModel;
  public groups: GroupModel[];
  public permission = {} as PermissionModel;
  public permissions: PermissionModel[];
  public grupoPermissao: GrupoPermissionModel;
  public editado = false;
  public adicionado = false;
  public edit = false;
  public msgErroEdit: string;
  public nameNewGrupo: string;
  public nameGrupoEdit: string;
  public permissionsEdit: PermissionModel[];
  public editPermission = 1;
  public permissionEdit = {} as GrupoVinculadoModel;
  public permissionLists: GrupoVinculadoModel[];
  public permissao: PermissionVinculadasModel[];
  horizontalPosition: MatSnackBarHorizontalPosition = 'right';
  verticalPosition: MatSnackBarVerticalPosition = 'top';

  constructor(
    private authService: AuthenticationService,
    private router: Router,
    private route: ActivatedRoute,
    private _snackBar: MatSnackBar,
    private permissionService: PermissionsService,
    private fb: FormBuilder
  ) {
    this.route.params.subscribe((params) => (this.grupoId = params['id']));

    //this.listarGrupoPermissaoUnico(this.grupoId);
    this.listPermissionsVinculadas(this.grupoId);
    if (this.grupoId === undefined) {
      this.listPermissionsVinculadas(0);
    }
  }

  ngOnInit() {
    this.formGrupoPermission = this.fb.group({
      id: ['', Validators.required],
      name: ['', Validators.required],
      permissions: [],
    });

    this.formGrupoEdit = this.fb.group({
      idGrupo: ['', Validators.required],
      descricaoGrupo: ['', Validators.required],
      permissionList: this.fb.array([this.createPermission()]),
    });

    this.listarGroups();
  }

  createPermission(): FormGroup {
    return this.fb.group({
      id: ['', [Validators.required]],
    });
  }

  onCheckboxChange(e, id: number) {
    const permissions: FormArray = this.formGrupoPermission.get(
      'permissions'
    ) as FormArray;

    if (e.target.checked) {
      permissions.push(new FormControl({ id: e.target.value }));
    } else {
      let i = 0;
      permissions.controls.forEach((item: FormControl) => {
        if (item.value.id === e.target.value) {
          permissions.removeAt(i);
          return;
        }
        i++;
      });
    }
  }

  reset() {
    this.router.navigate(['grupo-permissao']);
  }

  onSubmit() {
    this.submit = true;
  }

  saveOrEditCliente() {
    if (this.grupoId !== undefined) {
      this.editGrupo();
    } else {
      this.createNovoGrupo();
    }
  }

  createNovoGrupo() {
    console.log(this.grupoId);
    if (this.grupoId !== undefined) {
      let arrayId: any[] = [];
      this.permissionLists.forEach((el) => {
        el.permissionList.forEach((element) => {
          if (element.vinculado) {
            arrayId.push({ id: element.id });
          }
        });
      });
      this.formGrupoPermission.get('id').setValue(this.grupoId);
      this.formGrupoPermission.get('permissions').setValue(arrayId);
      console.log(this.formGrupoPermission.value);
      this.permissionService
        .editarGrupoPermission(this.formGrupoPermission.value)
        .subscribe(
          (data) => {
            this.openSnackBarSuccess('Grupo de Permissão atualizado com sucesso ! Redirecionando para listagem dos grupos.');
            setTimeout(() => {
              this.router.navigate(['grupo-permissao']);
            }, 3000);
          },
          (err) => {
            console.log(err);
            this.openSnackBarError('Erro ao tentar atualizar o Grupo de Permissão !');
          }
        );
    } else {
      let arrayId: any[] = [];
      this.permissionLists.forEach((el) => {
        el.permissionList.forEach((element) => {
          if (element.vinculado) {
            //arrayId.push(element.id);
            arrayId.push({ id: element.id });
          }
        });
      });
      this.formGrupoPermission.get('permissions').setValue(arrayId);
      this.permissionService
        .adicionarGrupoPermission(this.formGrupoPermission.value)
        .subscribe(
          (data) => {
            this.grupoPermissao = new GrupoPermissionModel();
            this.nameNewGrupo = data.name;
            this.openSnackBarSuccess(`Grupo de Permissão: ${data.name}, adicionado com sucesso!`);
            setTimeout(() => {
              this.router.navigate(['grupo-permissao']);
            }, 3000);
          },
          (err) => {
            this.msgErroEdit = err.error.message;
            this.openSnackBarError('Erro ao adicionar ! Preencha o campo nome para adicionar um Grupo.');
            console.error(err);
          }
        );
    }
  }

  editGrupo() {
    this.permissionService.editarGrupoPermission(this.grupoPermissao).subscribe(
      (data) => {
        this.openSnackBarSuccess('Grupo de Permissão atualizado com sucesso ! Redirecionando para listagem dos grupos.');
        setTimeout(() => {
          this.router.navigate(['grupo-permissao']);
        }, 3000);
      },
      (err) => {
        console.log(err);
        this.openSnackBarError('Erro ao tentar atualizar o Grupo de Permissão !');
      }
    );
  }

  listPermissionsVinculadas(idGrupo: number) {
    this.permissionService.listPermissoesVinculadosGrupo(idGrupo).subscribe(
      (data) => {
        console.log(data);
        this.permissionLists = data.permissaoVinculadas;
        if (data.hasParamInstance == 'true') {
          this.permissionLists.map(el => {
            if (el.idGrupo == 6) {
              let index = el.permissionList.findIndex(x => x.id == 27);
              el.permissionList.splice(index, 1);
            }
          })
        }

      },
      (err) => {
        console.error(err);
      }
    );
  }

  verificarInstantica() {
    this.permissionService.verificarInstancia().subscribe((data) => {
        console.log(data);
    }, err => {
      console.error(err);
    })
  }

  listarGroups() {
    this.permissionService.getAllGroups().subscribe(
      (data) => {
        this.groups = data;
        this.groups.forEach((el) => {
          for (let i = 0; i < el.permissions.length; i++) {
            for (let j = 0; j < i; j++) {
              this.permissions = el.permissions;
            }
          }
        });
      },
      (err) => {
        console.error(err);
      }
    );
  }

  listarGrupoPermissaoUnico(id: number) {
    this.permissionService.getGrupoUnico(id).subscribe(
      (data) => {
        this.grupoPermissao = data;
        this.nameGrupoEdit = this.grupoPermissao.name;
        this.permissionsEdit = this.grupoPermissao.permissions;
        if (this.grupoId !== null) {
          this.permissionsEdit.forEach((el) => {});
        }
      },
      (err) => {
        console.error(err);
      }
    );
  }

  listarPermissions(id: number) {
    this.permissionService.getPermissionGroup(id).subscribe(
      (data) => {
        this.permissions = data;
      },
      (err) => {
        console.error(err);
      }
    );
  }

  listarTodasPermissoes() {
    this.permissionService.getAllPermissions().subscribe(
      (data) => {
        this.permissions = data;
      },
      (err) => {
        console.error(err);
      }
    );
  }

  // SnackBares
  openSnackBarSuccess(message: string) {
    this._snackBar.open(message, '', {
      horizontalPosition: this.horizontalPosition,
      verticalPosition: this.verticalPosition,
      duration: 4000,
      panelClass: ['success-snackbar']
    });
  }

  openSnackBarError(message: string) {
    this._snackBar.open(message,'', {
      horizontalPosition: this.horizontalPosition,
      verticalPosition: this.verticalPosition,
      duration: 3000,
      panelClass: ['error-snackbar']
    });
  }
}



// WEBPACK FOOTER //
// /app/src/app/components/permissions/create-grupo-permission/create-grupo-permission.component.ts